import gql from 'graphql-tag';

const getTeamCreditsQuery = gql`
  query GetTeamCredits($organisationId: String!) {
    getTeamMemberships(organisationId: $organisationId) {
      team {
        teamId
        name
        creditBalance {
          balance
          rolloverBalance
        }
      }
    }
  }
`;

const getTeamCredits = (organisationId) => ({
  query: getTeamCreditsQuery,
  module: 'users',
  ignoreCache: true,
  buildVariables: () => ({ organisationId })
});

export default getTeamCredits;